var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1141_1177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V60H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1141_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1121 2.70422L51.9279 42.5628L59.8861 57.1035H0.113159L30.1121 2.70422ZM0.506979 56.8709H59.4937L30.1113 3.18721L0.506979 56.8709Z",
    fill: "#005FC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9279 42.5628L51.8259 42.6187M51.9279 42.5628L30.1121 2.70422L0.113159 57.1035H59.8861L51.9279 42.5628ZM0.506979 56.8709L30.1113 3.18721L59.4937 56.8709H0.506979Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3792 19.3796H29.2606L24.3546 34.5279L28.3838 33.8577L22.7572 52.3961L35.9573 28.7271L30.1565 29.3716L33.3792 19.3796Z",
    fill: "#A3C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3792 19.3796H29.2606L24.3546 34.5279L28.3838 33.8577L22.7572 52.3961L35.9573 28.7271L30.1565 29.3716L33.3792 19.3796Z",
    fill: "#A3C5EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.15 19.3438C29.1655 19.2958 29.2102 19.2633 29.2606 19.2633H33.3791C33.4163 19.2633 33.4513 19.2811 33.4731 19.3111C33.495 19.3412 33.5012 19.3799 33.4898 19.4153L30.3223 29.2361L35.9444 28.6114C35.9877 28.6066 36.03 28.6264 36.0541 28.6627C36.0782 28.6989 36.08 28.7456 36.0588 28.7836L22.8587 52.4527C22.8298 52.5046 22.7664 52.5263 22.7117 52.5031C22.657 52.4799 22.6286 52.4192 22.6459 52.3623L28.2181 34.003L24.3736 34.6425C24.3336 34.6492 24.293 34.6345 24.2665 34.6037C24.24 34.573 24.2314 34.5306 24.2439 34.492L29.15 19.3438ZM29.3452 19.4959L24.5241 34.3817L28.3646 33.7429C28.4043 33.7363 28.4446 33.7507 28.4711 33.7809C28.4976 33.8111 28.5067 33.8529 28.495 33.8914L23.1828 51.3942L35.7458 28.8675L30.1693 29.4871C30.1301 29.4915 30.0914 29.4757 30.0664 29.4451C30.0415 29.4145 30.0337 29.3734 30.0458 29.3359L33.2195 19.4959H29.3452Z",
    fill: "#005FC8",
    stroke: "#005FC8",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.46c15577.svg";
export { ForwardRef as ReactComponent };